import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "DJ Dejan - a NSFW blast from the past",
  "description": "",
  "published": "2009-11-29T00:00:00.000Z",
  "redirect_from": ["/blog/dj-dejan-a-nsfw-blast-from-the-past/swizec/916"],
  "categories": "funny, Humor, intrigues, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Mmkay, one for the slovenian oldfags who are gonna feel a bit old listening to this.`}</p>
    <p>{`Some very incredibly NSFW remakes of the popular hits we had to endure in the 90's.`}</p>
    <p>{`Have fun, don't report me to SAZAS. Thanks.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/DJ-Dejan-Vroce-Poletje-Morska-Vila.mp3"
      }}>{`DJ Dejan - Vroce Poletje (Morska Vila)`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/DJ-Dejan-Vracam-Se-Helena-B.mp3"
      }}>{`DJ Dejan - Vracam Se (Helena B)`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/DJ-Dejan-Trzinka.mp3"
      }}>{`DJ Dejan - Trzinka`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/DJ-Dejan-Reka-Prasic.mp3"
      }}>{`DJ Dejan - Reka Prasic`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/DJ-Dejan-Johnny-B.mp3"
      }}>{`DJ Dejan - Johnny B`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/DJ-Dejan-Jaz-Sem-Tvoja-Muca.mp3"
      }}>{`DJ Dejan - Jaz Sem Tvoja Muca`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/DJ-Dejan-Bum-Bum.mp3"
      }}>{`DJ Dejan - Bum Bum`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/DJ-Dejan-Brez-Mene.mp3"
      }}>{`DJ Dejan - Brez Mene`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      